import * as XLSX from "xlsx";

export function exportLedgerXlsx(rows, range, label = "Ledger") {
  const byCat = {};
  rows.forEach((r) => { byCat[r.category] = (byCat[r.category] || 0) + (r.amount || 0); });
  const summary = Object.entries(byCat)
    .sort((a, b) => b[1] - a[1])
    .map(([Kategori, Total]) => ({ Kategori, Total }));
  summary.push({ Kategori: "TOTAL", Total: rows.reduce((s, r) => s + (r.amount || 0), 0) });

  const tx = rows.map((r) => {
    const hasBill = r.bill_status !== undefined && r.bill_status !== null;
    return {
      Tanggal: (r.transaction_at || r.created_at || "").slice(0, 10),
      Customer: r.member_name,
      "No. HP": r.member_phone || "",
      Kategori: r.category,
      Tipe: r.txn_type || "visit",
      "Kelas/Lapangan": r.class_name || r.court || "",
      Catatan: r.note || "",
      "Jumlah Dibayar": r.amount || 0,
      "Total Tagihan": hasBill ? (r.bill_total || r.amount || 0) : (r.amount || 0),
      "Sudah Dibayar": hasBill ? (r.bill_paid ?? r.amount ?? 0) : (r.amount || 0),
      Sisa: hasBill ? (r.bill_remaining || 0) : 0,
      Status: hasBill ? r.bill_status : "PAID",
    };
  });

  const wb = XLSX.utils.book_new();
  const ws1 = XLSX.utils.json_to_sheet(summary);
  ws1["!cols"] = [{ wch: 26 }, { wch: 16 }];
  const ws2 = XLSX.utils.json_to_sheet(tx);
  ws2["!cols"] = [
    { wch: 12 }, { wch: 22 }, { wch: 16 }, { wch: 16 }, { wch: 12 },
    { wch: 20 }, { wch: 28 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 14 }, { wch: 10 },
  ];
  XLSX.utils.book_append_sheet(wb, ws1, "Ringkasan");
  XLSX.utils.book_append_sheet(wb, ws2, "Transaksi");
  XLSX.writeFile(wb, `HSC_${label}_${range.from}_${range.to}.xlsx`);
}

export function waNormalize(phone) {
  let d = (phone || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("0")) d = "62" + d.slice(1);
  else if (d.startsWith("8")) d = "62" + d;
  return d;
}

export function waInvoiceUrl(member, txn, bill) {
  const rp = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");
  const lines = [
    "*HSC — HIDDEN SPORTS CLUB*",
    "*INVOICE*",
    "",
    `Nama    : ${member.name}`,
    `Kategori: ${txn.category}`,
    `Jumlah  : ${rp(txn.amount)}`,
    `Tanggal : ${(txn.created_at || "").slice(0, 10)}`,
  ];
  if (txn.note) lines.push(`Catatan : ${txn.note}`);
  if (bill && bill.remaining > 0) {
    lines.push("", `Total Tagihan : ${rp(bill.total)}`, `Sudah Dibayar : ${rp(bill.paid)}`, `*Sisa Tagihan : ${rp(bill.remaining)}*`);
  }
  lines.push("", "Terima kasih telah menjadi bagian dari Hidden Sports Club.");
  const num = waNormalize(member.phone);
  const text = encodeURIComponent(lines.join("\n"));
  return num ? `https://wa.me/${num}?text=${text}` : `https://wa.me/?text=${text}`;
}
